// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"05694982","239":"1afc150c","453":"9948db96","455":"b8fb73a4"}[chunkId] + ".chunk.js";
};